'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Absolute
 *
 * The normal `Box` component but with `position: absolute` as a shortcut.
 *
 * @see Docs https://chakra-ui.com/box
 */
var Absolute = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    __css: {
      pos: 'absolute'
    }
  }, props, {
    ref: ref
  }));
});
Absolute.displayName = 'Absolut';
exports.Absolute = Absolute;